import Controller from "csi/action/Controller";
import Generate3DImagesDialog from "csi/middleware/imageTemplates3D/Generate3DImagesDialog";
import Generate3DImagesDialogStore from "csi/middleware/imageTemplates3D/Generate3DImagesDialogStore";
import localeProvider from "csi/page/localeProvider";
import { routerStore } from "csi/state/rootStore";
import xml from "csi/xml";
import Search from "csi/xml/Search";
import declare from "dojo/_base/declare";
import { C8Node, C8NodeType } from "src/c8-platform/type/node";

const ImageGenerateController = declare(Controller, {
	
	/** Map to determine the product type of the node */
	productTypeFunctionMap(node: C8NodeType): Record<string, (node: C8Node) => C8NodeType> {
		return {
			Colorway: (node) => this.m_cache.get(node.Style)?.ProductType,
			Material: (node) => node.ProductType,
			Style: (node) => node.ProductType,
		};
	},	

	/** 
	 * Get ProductType
	 */
	getProductType(): string | undefined {
		const node = this.getNode();
		const functionMap = this.productTypeFunctionMap(node.$Type);
		const fn = functionMap[node.$Type];
		return fn ? fn(node) : undefined; 
	},	

	/**
	 * @override
	 * Open React dialog
	 */
	async preProcess(): Promise<void> {
		const { widget, m_cache } = this;
		await Promise.all([
			this.getEnvironmentNodes(),
			this.getCameraPositionNodes(),
		]);
		const productType = this.getProductType();
		const nodeType = widget.getViewNodeType();
		const onSave = ():void => {
			this.processReact();
		};	
		const onCancel = (): void => {
			this.onCancelReactDialog();
		};
		const store = new Generate3DImagesDialogStore(m_cache, localeProvider, nodeType, widget.urlRoot, productType, onCancel, onSave);
		this.useReactDialog(routerStore.openDialog(Generate3DImagesDialog, {
			store,
		}));
	},

	/**
	 * Get dependencies for the cache
	 */
	async getEnvironmentNodes() {
		const { m_cache } = this;

		const search = new Search()
			.byType("ThreeDEnvironment");
		const query = search.getQuery();
		query.Attr("Active", xml.OP_EQUALS, true);
		search.getSortQuery()
			.SortByNode(xml.PROP_CREATE_TIME, null, true);

		const response = await search.getRequest()
			.go();
		
		m_cache.cacheResponse(response);
	},

	/**
	 * Get dependencies for the cache
	 */
	async getCameraPositionNodes() {
		const { m_cache } = this;
			
		const search = new Search()
			.byType("CameraPosition");
		const response = await search.getRequest()
			.go();
			
		m_cache.cacheResponse(response);
	},
});

export = ImageGenerateController;